module.exports = __webpack_public_path__ + "prod/1.42.2/img/solution4.700ea697.png";